import { FRANCHISE } from '~/constants/franchise';
import { useFranchise } from '~/shared/utils';

// Temporary hardcoded config until the BE endpoint provides key and enabled markets.
export const VIABILL_PRICETAG_KEY = '8jwplwK_scU%3D';
export const VIABILL_SCRIPT_URL = `https://pricetag.viabill.com/script/${VIABILL_PRICETAG_KEY}`;
export const VIABILL_SCRIPT_ID = 'viabill-pricetag-script';

const VIABILL_ENABLED_FRANCHISES = [FRANCHISE.LINDBERGH, FRANCHISE.TOEJEKSPERTEN];

export const useIsViabillEnabled = () => {
    const { key, activeMarket } = useFranchise();

    return (
        VIABILL_ENABLED_FRANCHISES.includes(key) &&
        activeMarket?.currency === 'DKK' &&
        activeMarket?.countryKey === 'DK'
    );
};
